// Item / attribute derivation for the info-view compare-items block, ported from the coffee
// view (calcConceptAttributes / calcConceptItems). Attributes are the table columns built from
// a batch's answer variants; items are the per-batch rows with one cell per attribute.

import { formatAmounts } from '@aytm/app/stats/lib/util/helpers'
import { removeTagsFromText } from '@aytm/app/stats/page/components/lib/utils'

// The first real answer-variant column; -1 when there are no attributes at all.
export const getMainAttributePosition = (attributes = []) => (attributes.length ? 1 : -1)

export const calcConceptAttributes = (batches = []) => {
  if (!batches.length) return []

  const batch = batches.find(b => b && Array.isArray(b.answerVariants) && 0 < b.answerVariants.length)
  if (!batch) return []

  return [
    { text: 'Original order', position: 0, main: false, hidden: true },
    ...batch.answerVariants.map(av => ({
      text: removeTagsFromText(av.text || ''),
      position: av.position,
      main: false
    })),
    { text: 'Sample size', position: 'sample_size', main: false, info: true }
  ]
}

const calcOriginalOrderCell = (batch, batchesCount) => ({
  percents: batchesCount - batch.position,
  amount: batchesCount - batch.position,
  text: String(batch.position)
})

const calcSampleSizeCell = (answer, splitBy) => {
  const cell = {
    amount: null != answer.total ? answer.total : null,
    text:
      null != answer.total && 0 !== answer.total ? formatAmounts(answer, 'total', 1) : null != answer.total ? '0' : null
  }

  if (null != splitBy?.ref && Object.hasOwn(answer, splitBy.ref)) {
    cell[splitBy.ref] = Object.keys(answer[splitBy.ref]).reduce((acc, cur) => {
      const total = answer[splitBy.ref][cur].total
      acc[cur] = {
        amount: null != total ? total : null,
        text: null != total && 0 !== total ? formatAmounts(total, null, 1) : null != total ? '0' : null
      }
      return acc
    }, {})
  }

  return cell
}

const calcAttributeCell = (answer, attribute, splitBy) => {
  const answerAttribute = answer[`a${attribute.position}`] || {}

  const cell = {
    title: answerAttribute.title,
    percents: answerAttribute.percents,
    amount: answerAttribute.amount,
    rank: answerAttribute.rank || null,
    text: answerAttribute.text || null,
    sigtext: answerAttribute.sigtext || answerAttribute.sigtestAvg || null,
    sigtest: answerAttribute.sigtest || null,
    empty:
      undefined === answerAttribute.percents && undefined === answerAttribute.amount && !answerAttribute.sigtest?.length
  }

  if (null != splitBy?.ref && Object.hasOwn(answerAttribute, splitBy.ref)) {
    cell[splitBy.ref] = answerAttribute[splitBy.ref]
  }

  return cell
}

export const calcConceptItems = ({ batches = [], answer, attributes = [], splitBy } = {}) => {
  if (!batches.length) return []

  return batches.map(batch => {
    const batchAnswer = answer?.[`b${batch.position}`] || { rank: 0 }

    return {
      position: batch.position,
      text: removeTagsFromText(batch.text || ''),
      image: batch.image,
      attributes: attributes.map(attribute => {
        if (0 === attribute.position) return calcOriginalOrderCell(batch, batches.length)
        if ('sample_size' === attribute.position) return calcSampleSizeCell(batchAnswer, splitBy)
        return calcAttributeCell(batchAnswer, attribute, splitBy)
      })
    }
  })
}
